<template>
<v-app id="inspire" :style="{ background: $vuetify.theme.themes[theme].background }">
  <Sidebar :platform="loginPlatform" :menu-items="null" :auto-expand="false"></Sidebar>
  <Navbar>
    <template #custom="{ active }">
      <NavigationTitle text="QR Dashboard"></NavigationTitle>
    </template>
    <template #right-custom="{ active }">
      <v-btn text @click="navigateToTeams" class="mr-2">
        <v-icon left>mdi-account-group</v-icon>
        Teams
      </v-btn>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <span
            v-bind="attrs"
            v-on="on"
            class="caption grey--text text--darken-1 mr-4"
            style="cursor: default"
          >
            Last Update: {{ lastUpdateAgo }}
          </span>
        </template>
        <span>{{ lastUpdateFull }}</span>
      </v-tooltip>
    </template>
  </Navbar>
  <v-main id="v4-content">
    <v-container fluid>
      <router-view :key="$route.fullPath"></router-view>
    </v-container>
  </v-main>
</v-app>
</template>

<script>
import Vue from "vue"
import {mapGetters} from "vuex"
import AppMixin from "@/base_lib/data/mixins/appMixin"
import PageMixin from "@/base_lib/data/mixins/pageMixin"
import Sidebar from "@/base_lib/view/navigation/Sidebar"
import Navbar from "@/base_lib/view/navigation/Navbar"
import NavigationTitle from "@/components/NavigationTitle"
import Button from "@/base_lib/components/form/Button"
import EditorService from "@/services/EditorServices"
import router from "@/router"
import buildInfo from "@/build-info.json"
import moment from "moment"

export default {
  name: "Home",
  components: {NavigationTitle, Navbar, Sidebar, Button},
  mixins: [AppMixin, PageMixin],
  computed: {
    ...mapGetters({
      loginPlatform: 'auth/platform',
    }),
    lastUpdateAgo() {
      return moment(buildInfo.lastCommitDate).fromNow()
    },
    lastUpdateFull() {
      return moment(buildInfo.lastCommitDate).format('YYYY-MM-DD HH:mm')
    },
  },
  methods: {
    onCreateIssueClick() {
      Vue.prototype.$showCollectorDialog()
    },
    navigateToTeams() {
      router.push({ name: 'teams' })
    },
    async checkEditorAccess() {
      try {
        await EditorService.getEditor()
      } catch (error) {
        // Check if error is 4xx (400-499)
        const status = error?.response?.status || error?.status
        if (status >= 400 && status < 500) {
          // Logout and redirect to login
          await Promise.all([
            Vue.prototype.$stateManagement.dispatch('teams/logout'),
            Vue.prototype.$stateManagement.dispatch('auth/logout')
          ])
          router.push({ name: 'login', query: { flash: 'Your session has expired. Please login again.' } })
        }
      }
    },
  },
  mounted() {
    this.checkEditorAccess()
  },
}
</script>

<style scoped>
#v4-content {
  margin-top: 0px;
  margin-left: 260px;
  margin-right: 0px;
  min-height: 100vh;
}
</style>
